import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import check from "../../assets/check.png";
import Button from "../../components/Button/Button";
import { useHistory } from "react-router";

const ConfirmPay = () => {
	const { t } = useTranslation();
	const history = useHistory();

	useEffect(() => {
		setTimeout(() => {
			history.push("/home");
		}, 10000);
	}, []);
	return (
		<>
			<Box
				sx={{
					backgroundColor: "#f7f7f7",
					height: "100vh",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Box
					sx={{
						textAlign: "center",
					}}
				>
					<img src={check} width={150} height={130} />
					<h1 style={{ fontSize: "58px", color: "#333333" }}>{t("thanks")}</h1>
					<h3 style={{ color: "#524a41" }}>{t("receive_email")}</h3>
					<Button
						text={t("return_home")}
						style={{ width: "180px", marginTop: "20px" }}
						onClick={() => history.push("/home")}
					/>
				</Box>
			</Box>
		</>
	);
};
export default ConfirmPay;
